// The only outbound data in the app. Queue + retry; never blocks the UI.
const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "ailab.wrapQueue";

const readQ = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};
const writeQ = (q) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(q));
  } catch {
    // ignore
  }
};

async function send(payload) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 8000);
  try {
    const res = await fetch(`${API}/api/wrap`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    if (!res.ok) throw new Error("bad status");
  } finally {
    clearTimeout(timer);
  }
}

export async function submitWrap(payload) {
  try {
    await send(payload);
  } catch {
    const q = readQ();
    q.push(payload);
    writeQ(q);
  }
}

export async function flushWrapQueue() {
  const q = readQ();
  if (!q.length) return;
  const remaining = [];
  for (const p of q) {
    try {
      await send(p);
    } catch {
      remaining.push(p);
    }
  }
  writeQ(remaining);
}
